// 9fbef606107a605d69c0edbcd8029e5d
import { COUPON_ACTION_PATTERN } from '../../../../../../constants/reducer.constants';

const COUPON_CONSTANTS = {
  SHOW_LOADER: `${COUPON_ACTION_PATTERN}SHOW_LOADER`,
  HIDE_LOADER: `${COUPON_ACTION_PATTERN}HIDE_LOADER`,
  APPLY_COUPON: `${COUPON_ACTION_PATTERN}APPLY_COUPON`,
  GET_COUPON_LIST: `${COUPON_ACTION_PATTERN}GET_COUPON_LIST`,
  SET_COUPON_LIST: `${COUPON_ACTION_PATTERN}SET_COUPON_LIST`,
  SET_BONUS_POINT_DAY: `${COUPON_ACTION_PATTERN}SET_BONUS_POINT_DAY`,
  SET_BONUS_POINT_DAY_COUPON_INDEX: `${COUPON_ACTION_PATTERN}SET_BONUS_POINT_DAY_COUPON_INDEX`,
  CLEAR_COUPON_TTL: `${COUPON_ACTION_PATTERN}CLEAR_COUPON_TTL`,
  REMOVE_COUPON: `${COUPON_ACTION_PATTERN}REMOVE_COUPON`,
  SET_STATUS_COUPON: `${COUPON_ACTION_PATTERN}SET_STATUS_COUPON`,
  SET_COUPON_APPLIED_STATUS: `${COUPON_ACTION_PATTERN}SET_COUPON_APPLIED_STATUS`,
  SET_ERROR: `${COUPON_ACTION_PATTERN}SET_ERROR`,
  RESET_COUPON_STATE: `${COUPON_ACTION_PATTERN}RESET_COUPON_STATE`,
  RESET_COUPON_REDUCER: `${COUPON_ACTION_PATTERN}RESET_COUPON_REDUCER`,
  GET_COUPON_LIST_TTL: 10 * 60 * 1000,
  COUPONS_FETCH_TIMEOUT: 10 * 60 * 1000,
  ACCOUT_DRAWER_COUPONS_FETCH_CACHE_TTL: 15 * 60 * 1000,
  SET_COUPONS_FETCH_TIMESTAMP: 'SET_COUPONS_FETCH_TIMESTAMP', // Set timestamp on the redux state
  COUPONS_UPDATE_TIMEOUT: 'COUPONS_UPDATE_TIMEOUT', // Async storage key to set and get last api call time
  TOGGLE_NEED_HELP_MODAL_STATE: 'TOGGLE_NEED_HELP_MODAL_STATE',
  SET_NEED_HELP_MODAL_STATE: 'SET_NEED_HELP_MODAL_STATE',
  SET_ONHOLD_COUPON: 'SET_ONHOLD_COUPON',
  GET_COUPON_TERMS_AND_CONDITIONS: 'GET_COUPON_TERMS_AND_CONDITIONS',
  SET_COUPON_TERMS_AND_CONDITIONS: 'SET_COUPON_TERMS_AND_CONDITIONS',
  GET_COUPON_DETAILS: 'GET_COUPON_DETAILS',
  SET_COUPON_DETAILS: 'SET_COUPON_DETAILS',
  RESET_COUPON_DETAILS: 'RESET_COUPON_DETAILS',
  SET_COUPON_DETAILS_ERROR: 'SET_COUPON_DETAILS_ERROR',
  SET_COUPON_DETAILS_LOADER: 'SET_COUPON_DETAILS_LOADER',
  SET_APPLY_COUPON_CSH_LOADER: 'SET_APPLY_COUPON_CSH_LOADER',
  SET_APPLY_COUPON_CSH_ERROR: 'SET_APPLY_COUPON_CSH_ERROR',
  GET_MY_REWARD_COUPON_LIST: 'GET_MY_REWARD_COUPON_LIST',
  CALL_COUPON_ACTION: 'CALL_COUPON_ACTION',
  FROM_COUPON_TAB: 'FROM_COUPON_TAB',
  FROM_APPLY: 'FROM_APPLY',
  UPDATE_COUPON_LIST_ON_HOLD: `${COUPON_ACTION_PATTERN}UPDATE_COUPON_LIST_ON_HOLD`,
  UPDATE_COUPON_LIST_EXPIRED: `${COUPON_ACTION_PATTERN}UPDATE_COUPON_LIST_EXPIRED`,
  SET_COUPON_CODE: `${COUPON_ACTION_PATTERN}SET_COUPON_CODE`,
  APPLY_PLACE_BUCKS: `${COUPON_ACTION_PATTERN}APPLY_PLACE_BUCKS`,
  SET_LAST_APPLIED_COUPON: `${COUPON_ACTION_PATTERN}SET_LAST_APPLIED_COUPON`,
  SET_OPEN_COUPON_DETAIL_MODAL: `${COUPON_ACTION_PATTERN}SET_OPEN_COUPON_DETAIL_MODAL`,
  TOGGLE_MULTI_LOADER: `${COUPON_ACTION_PATTERN}TOGGLE_MULTI_LOADER`,
  SET_MULTI_ADD_SUCCESS: `${COUPON_ACTION_PATTERN}SET_MULTI_ADD_SUCCESS`,
  SET_MULTI_ADD_ERROR: `${COUPON_ACTION_PATTERN}SET_MULTI_ADD_ERROR`,
};

export default COUPON_CONSTANTS;
